<template>
  <div class="sales-view workbench-body">
    <div class="workbench-body-left">
      <div class="briefing">
        <mk-card>
          <div
            slot="header"
            class="clearfix"
          >
            <div>
              数据简报
              <mk-popover
                class="h-title"
                placement="left"
                trigger="hover"
                reference=""
              >
                <div class="h-t-popover">
                  <span>线索数：</span>
                  即销售线索，可以进行跟踪、转化的潜在客户。<br />
                  <span>浏览量（PV）：</span>
                  即⻚⾯浏览量，⽤户每次刷新即被计算⼀次。
                </div>
                <template slot="reference">
                  <mk-iconfont
                    class="icon"
                    icon-class="question-mark"
                  ></mk-iconfont>
                </template>
              </mk-popover>
            </div>
          </div>
          <div class="briefing-body">
            <div class="briefing-item">
              <div class="briefing-count">
                {{ briefingData.countClueTotal || 0 }}
              </div>
              <div class="briefing-type">
                <span>线索数</span>
                <span>日新增
                  <span class="highlight">{{
                    briefingData.countClueNew || 0
                  }}</span></span>
              </div>
            </div>
            <div class="line"></div>
            <div class="briefing-item">
              <div class="briefing-count">
                {{ briefingData.countPVTotal || 0 }}
              </div>
              <div class="briefing-type">
                <span>浏览量（PV）</span>
                <span>日新增
                  <span class="highlight">{{
                    briefingData.countPVNew || 0
                  }}</span></span>
              </div>
            </div>
            <!-- <div class="line"></div>
            <div class="briefing-item">
              <div class="briefing-count">
                2222
              </div>
              <div class="briefing-type">
                <span>已关联微信</span>
                <span>好友的线索</span>
              </div>
            </div> -->
          </div>
        </mk-card>
      </div>
      <div
        class="radar"
      >
        <mk-card v-loading="radarListLoading">
          <div
            slot="header"
            class="clearfix radar-list-header-c"
          >
            <span>雷达</span>
          </div>
          <div
            v-infinite-scroll="load"
            class="radar-list"
            :infinite-scroll-immediate="false"
            :infinite-scroll-disabled="scrollDisabled"
          >
            <ul
              v-if="radarList.length > 0"
            >
              <li
                v-for="(item, index) in radarList"
                :key="index"
                class="radar-item"
              >
                <div class="radar-item-main">
                  <div class="radar-user-portrait">
                    <img
                      v-if="item.avatarUrl"
                      :src="item.avatarUrl"
                      alt="error"
                      class="img"
                    />
                    <no-avatar v-else />
                  </div>
                  <div class="radar-info">
                    <div class="info-left">
                      <div class="user-action">
                        <span
                          class="material-name-color"
                          @click="openDialog(item)"
                        >{{ item.nickName }}</span>
                        {{ item.userAction }}
                        <template v-if="item.stayTime">
                          ，{{ item.platformTxt }}停留了{{ item.stayTime }}秒
                        </template>
                      </div>
                      <div
                        v-if="item.tagOverview && item.tagOverview.length > 0"
                        class="user-tags"
                      >
                        <mk-tag
                          v-for="(tag, tagIndex) in item.tagOverview.slice(0,3)"
                          :key="tagIndex"
                        >
                          <!-- 兼容之前老数据，老数据没有分数，显示+1 -->
                          {{ tag.tName }} +{{
                            tag.tagScore ? tag.tagScore : 1
                          }}
                        </mk-tag>
                        <tag-popover
                          v-if="item.tagOverview.length > 3"
                          :tag-list="item.tagOverview"
                        ></tag-popover>
                      </div>
                    </div>
                    <div class="info-right">
                      <div class="action-time">
                        {{ item.formatDate }}
                      </div>
                      <div class="action-type lead">
                        <template v-if="item.secondScene === '2'">
                          来自：自主访问
                        </template>
                        <template v-else-if="item.fromPerson">
                          来自：{{ item.fromPersonCn }}
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="radar-item-other-info">
                  <mk-timeline>
                    <mk-timeline-item hide-timestamp>
                      <div class="other-info-item">
                        <div>
                          <div class="other-info-time">
                            11:00
                          </div>
                          <div class="other-info-action">
                            访问了页面
                          </div>
                        </div>
                        <div class="from-scene">
                          来自：苹果小姐转发
                        </div>
                      </div>
                    </mk-timeline-item>
                    <mk-timeline-item hide-timestamp>
                      <div class="other-info-item">
                        <div>
                          <div class="other-info-time">
                            11:00
                          </div>
                          <div class="other-info-action">
                            访问了页面
                          </div>
                        </div>
                        <div class="other-info-tag">
                          <mk-tag
                            v-for="(tag, tagIndex) in item.tagScoreInc"
                            :key="tagIndex"
                            type="success"
                            :style="{'borderColor' : tag.borderColor, 'backgroundColor': tag.bgColor, 'color' : tag.fontColor}"
                          >
                            {{ tag.tName }} (+{{ tag.tagScore }})
                          </mk-tag>
                          <span
                            v-if="item.countTags > 3"
                            class="tag-count"
                          >等{{ item.countTags }}个标签</span>
                        </div>
                      </div>
                    </mk-timeline-item>
                  </mk-timeline>
                </div> -->
              </li>
            </ul>
            <template v-else>
              <no-data v-if="!radarListLoading" />
            </template>
          </div>
        </mk-card>
      </div>
    </div>
    <div class="workbench-body-right">
      <div class="statistics">
        <mk-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>我的营销统计</span>
          </div>
          <no-data place-holder="即将上线，敬请期待" />
        </mk-card>
      </div>
    </div>
    <friend-details
      v-if="visible"
      :visible.sync="visible"
      :friend-data="friendData"
    ></friend-details>
  </div>
</template>

<script>
import {
  eventFormat,
  formatInfo,
  materialFormat,
  commonMaterial,
  platformFormat,
  personFormat,
  operateEntity
} from '@/utils/userActionFormat'
import FriendDetails from '@/views/wechat-lead/components/friend-details'
import TagPopover from '@/components/tag-popover'
import NoData from '@/components/no-data'
import dayjs from 'dayjs'
import { CLUEAPIS } from '@api'
import NoAvatar from '@components/no-avatar'
export default {
  name: 'SalesView',
  components: {
    FriendDetails,
    NoData,
    TagPopover,
    NoAvatar
  },
  data () {
    return {
      // 雷达的数据
      radarList: [],
      // 雷达列表的loading
      radarListLoading: false,
      // 雷达当前页
      page: 1,
      // 雷达总页数
      totalPage: 0,
      // 简报数据
      briefingData: {},
      // 详情弹窗是否可见
      visible: false,
      // 弹窗数据
      friendData: {},
      // 来源的数据
      sceneObj: {},
      scrollDisabled: false // 是否继续滚动加载数据
    }
  },
  mounted () {
    this.workbenchShowGroupRadarGet()
    this.workbenchSaleViewOverviewGet()
    this.wxclueSceneGet()
  },
  methods: {
    // 查询雷达数据
    async workbenchShowGroupRadarGet (page = 1) {
      this.radarListLoading = true
      let params = {
        page,
        pageSize: 10
      }
      let res = await CLUEAPIS.ClueApi.clueMkRadarGet(params)
      const userNameMap = await this.getUserNameMap()
      this.radarListLoading = false
      if (res.success) {
        let data = res.data.list ? res.data.list : []
        if (data.length < 10) {
          this.scrollDisabled = true
        }
        this.totalPage = Math.ceil(res.data.total / res.data.pageSize)
        data.forEach(item => {
          let userName = userNameMap[item.userId]
            ? userNameMap[item.userId]
            : ''
          item.userName = personFormat(userName)
          this.formatDate(item)
          this.userActionFormat(item, item.materialSourceType)
          // 转发/分享人是谁
          if (item.secondScene === '1') {
            item.fromPerson = item.forwardClueName
            item.fromPersonCn = item.fromPerson + '的转发'
          } else if (item.secondScene === '0') {
            let userId = item.shareActionInfo
              ? item.shareActionInfo.userId
              : item.userId
            item.fromPerson = userNameMap[userId] || ''
            item.fromPersonCn = item.fromPerson + '的分享'
          }
        })

        this.radarList = [...this.radarList, ...data]
      }
    },
    // 获取所有的user信息，并组装为map结构
    async getUserNameMap () {
      let user = await this.$DexiePlguin.getAllUser()
      let userNameMap = {}
      user.forEach(item => {
        if (item) {
          userNameMap[item._id] = item.name
        }
      })
      return userNameMap
    },
    // 查询来源
    async wxclueSceneGet () {
      this.loading = true
      let res = await CLUEAPIS.ClueApi.clueMkSceneGet()
      if (res.success) {
        this.sceneObj = res.data
      }
    },
    // 查询简报
    async workbenchSaleViewOverviewGet () {
      let res = await BIZAPIS.WorkbenchApi.workbenchSaleViewOverviewGet()
      if (res.success) {
        this.briefingData = res.data
      }
    },
    // 查询微信线索详情
    async wxclueInformationGet (unionId) {
      let res = await CLUEAPIS.ClueApi.clueMkDetailGet({ unionId })
      return res
    },
    // 查询微信线索信息-微信会话
    async wxclueWxclueWxcontactGet (unionId) {
      let res = await BIZAPIS.WxclueApi.wxclueWxclueWxcontactGet({ unionId })
      return res
    },
    // 打开详情弹窗
    async openDialog (data) {
      this.radarListLoading = true
      let res = await Promise.all([
        this.wxclueInformationGet(data.unionId),
        this.wxclueWxclueWxcontactGet(data.unionId)
      ])
      this.radarListLoading = false
      if (res[0].success) {
        this.friendData = {
          ...res[0].data
        }
        this.friendData.fromSceneText = ''
        if (this.sceneObj instanceof Array) {
          this.sceneObj.forEach(item => {
            if (this.friendData.firstScene === item._id) {
              this.friendData.fromSceneText += item.name + '/'
              if (item.children instanceof Array) {
                item.children.forEach(itemC => {
                  if (this.friendData.secondScene === itemC._id) {
                    this.friendData.fromSceneText += itemC.name
                  }
                })
              } else {
                this.friendData.fromSceneText = item.name
              }
            }
          })
        }
        // 计算count总数
        this.friendData.count = 0
        if (this.friendData.clueUA) {
          this.friendData.clueUA.forEach(item => {
            this.friendData.count += item.visitCount
          })
        }
      }
      if (res[1].success) {
        this.friendData = {
          ...this.friendData,
          m7WxNo: res[1].data.m7WxNo,
          m7Uid: res[1].data.m7Uid
        }
      }
      this.visible = true
    },
    // 无限滚动加载
    load () {
      if (this.page < this.totalPage && !this.radarListLoading) {
        this.workbenchShowGroupRadarGet(++this.page)
      }
    },
    formatDate (item) {
      let year = dayjs(new Date()).format('YYYY')
      let day = dayjs(new Date()).format('DD')
      let second = dayjs(new Date()).unix()
      let ym = dayjs(new Date()).format('YYYY-MM')
      let ymd = dayjs(new Date()).format('YYYY-MM-DD')
      let hm = item.triggerTime.slice(10, 16)
      let itemFullDate = item.triggerTime
      let itemDay = item.day.slice(8, 10)
      let itemSecond = dayjs(itemFullDate).unix()
      if (item.day === ymd) {
        // 为今天
        if (second - itemSecond < 60) {
          item.formatDate = `刚刚`
        } else if (second - itemSecond > 60 && second - itemSecond < 3600) {
          let minutes = Math.floor((second - itemSecond) / 60)
          item.formatDate = `${minutes}分钟前`
        } else {
          // 大于一小时
          item.formatDate = `${item.day.slice(5, 10)} ${hm}`
        }
      } else if (item.year === year) {
        item.formatDate = `${item.day.slice(5, 10)} ${hm}`
      } else {
        item.formatDate = `${item.day} ${hm}`
      }
    },
    async getUser (userId) {
      let saleInfo = await this.$DexiePlguin.getUserById(userId)
      return saleInfo
    },
    userActionFormat (item) {
      let that = this
      if (item.platform === 'MINI') {
        item.platformTxt = '在小程序中'
      }
      let id = JSON.parse(window.localStorage.getItem('user')).id
      if (item.userId === id) {
        item.userAction = `${formatInfo(item)}你的`
        if (item.operateEntity === 'material') {
          item.userAction += `${materialFormat(item.materialInfo[0].type)}《${item.materialInfo[0].title}》`
        } else if (item.operateEntity === 'commonMaterial') {
          item.userAction += `${commonMaterial(item.commonMaterialInfo[0].type)}《${item.commonMaterialInfo[0].title}》`
        } else if (item.operateEntity === 'miniMaterial') {
          item.userAction += `文件${item.miniMaterialInfo[0].title}`
        } else {
          item.userAction += operateEntity(item.operateEntity)
        }
      } else {
        this.getUser(item.userId).then((data) => {
          item.userAction = `${formatInfo(item)}${data && data.name}的`
          if (item.operateEntity === 'material') {
            item.userAction += `${materialFormat(item.materialInfo[0].type)}《${item.materialInfo[0].title}》`
          } else if (item.operateEntity === 'commonMaterial') {
            item.userAction += `${commonMaterial(item.commonMaterialInfo[0].type)}《${item.commonMaterialInfo[0].title}》`
          } else if (item.operateEntity === 'miniMaterial') {
            item.userAction += `文件${item.miniMaterialInfo[0].title}`
          } else {
            item.userAction += operateEntity(item.operateEntity)
          }
          this.radarList = this.radarList.concat([])
        }).catch(() => {
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.workbench-body {
  display: flex;
  height: calc(100% - 2px);
  min-height: 600px;

  a {
    text-decoration: none;
  }

  // .radar-list-header-c {
  //   position: relative !important;
  //   z-index: 9999 !important;
  // }

  .workbench-body-left {
    flex: 2;
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    .briefing {
      .briefing-body {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .briefing-item {
          display: flex;
          flex-direction: column;
          position: relative;
          text-align: center;

          .briefing-count {
            color: #262626;
            font-size: 20px;
            font-weight: 500;
            line-height: 38px;
          }

          .briefing-type {
            display: flex;
            margin-top: 7px;
            flex-direction: column;
            color: #8c8c8c;
            font-size: 13px;
            line-height: 22px;
          }
        }

        .line {
          display: block;
          width: 1px;
          height: 40px;
          background-color: #e9e9e9;
        }
      }
    }

    .radar {
      margin-top: 10px;
      height: 100%;
      flex: 1;
      overflow: hidden;

      .mk-card {
        display: flex;
        flex-direction: column;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
      }

      .radar-list {
        height: calc(100% - 1px);
        overflow: auto;
      }

      /deep/ .el-card__body {
        padding: 0;
        flex: 1;
        overflow: hidden;
      }

      .radar-item {
        padding: 0 20px;
        border-bottom: 1px solid #e8e8e8;

        .radar-item-main {
          padding: 20px 0 16px;
          // height: 80px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
        }

        .radar-user-portrait {
          height: 36px;
          width: 36px;
          border-radius: 4px;
          overflow: hidden;

          .img {
            width: 100%;
            height: 100%;
          }
        }

        .radar-info {
          display: flex;
          flex: 1;
          margin-left: 10px;

          .info-left {
            flex: 1;
            display: flex;
            justify-content: center;
            flex-direction: column;

            .el-tag {
              height: 22px;
              line-height: 22px;
              margin: 5px 10px 0 0;
            }
          }

          .info-right {
            text-align: right;
          }
        }

        .user-action,
        .action-time {
          font-size: 13px;
          line-height: 18px;
        }

        .user-action {
          color: #595959;

          .material-name-color {
            color: #009cff;

            @extend .cursor;
          }
        }

        .user-tags {
          .tag-count {
            margin-left: 8px;
            font-size: 12px;
            color: #8c8c8c;
          }

          .mk-tag {
            border-radius: 2px;
            padding: 0 8px;
            background: rgba(235, 239, 244, 1);
            color: #6b7b88;
            border: none;
          }
        }

        .action-time {
          color: #bfbfbf;
        }

        .action-type {
          font-size: 13px;
          line-height: 18px;
          color: #888;
          margin-top: 11px;
        }
      }

      .radar-item-other-info {
        padding-left: 14px;
        margin-top: 17px;

        .el-timeline-item {
          padding-bottom: 0;
        }

        /deep/ .el-timeline-item__wrapper {
          top: -20px;
        }

        .other-info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          padding: 0 15px;
          height: 52px;
          background-color: #f5f5f5;
          border-bottom: 1px solid #fff;

          .other-info-time {
            color: #888;
            font-size: 12px;
            line-height: 17px;
          }

          .other-info-action {
            margin-top: 5px;
            color: #262626;
            font-size: 13px;
            line-height: 18px;
          }

          .from-scene {
            font-size: 13px;
            color: #888;
          }
        }
      }

      .no-data {
        padding: 20px;
      }
    }
  }

  .workbench-body-right {
    flex: 1;
    margin: 0 10px;

    .statistics {
      height: 100%;

      .el-card {
        height: 100%;
      }

      /deep/ .el-card__body {
        height: calc(100% - 60px);
        box-sizing: border-box;
      }
    }
  }

  .h-title {
    .icon {
      font-size: 16px;
      color: #888;
      font-weight: normal;
      cursor: pointer;
    }
  }
}

.h-t-popover {
  font-size: 14px;
  color: #262626;
  line-height: 24px;

  span {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
  }
}
</style>
